'use strict';

(function() {
  const module = angular.module('client.components');

  controller.$inject = ['$route'];

  function controller($route) {
    const ctrl = this;
    const routeParams = $route.current && $route.current.params
      ? $route.current.params
      : {};

    ctrl.skillKey = routeParams.skillKey;
  }

  module.component('xpAcademySkill', {
    template: require('./academySkill.jade'),
    controller,
  });
})();
